export const constantConfigs = {
  facebook: {
    host: 'https://www.facebook.com/',
  },
  eventbrite: {
    host: 'https://www.eventbrite.com/o/',
  },
  eventful: {
    host: 'http://losangeles.eventful.com/',
  },
};

export const placeCategoryEnum = [
  {
    key: 'all',
    value: 'All',
  },
  {
    key: 'dining-nightlife',
    value: 'Dining & Nightlife',
  },
  // {
  //     key: 'arts-culture',
  //     value: 'Arts & Culture'
  // },
  {
    key: 'shopping',
    value: 'Shopping',
  },
  {
    key: 'shopping',
    value: 'Shoppings',
  },
  {
    key: 'accommodation',
    value: 'Accommodations',
  },
  {
    key: 'accommodation',
    value: 'Accommodation',
  },
  {
    key: 'arts-culture',
    value: 'Arts & Culture',
  },
  {
    key: 'activities',
    value: 'Activities',
  },
  {
    key: 'outdoors-fitness',
    value: 'Outdoors & Fitness',
  },
  {
    key: 'entertainment',
    value: 'Entertainment',
  },
  {
    key: 'transportation',
    value: 'Travel',
  },
  {
    key: 'other',
    value: 'Other',
  },
  {
    key: 'beauty',
    value: 'Beauty',
  },
  {
    key: 'cars-motor-services',
    value: 'Cars & Motor Services',
  },
  {
    key: 'cleaning-services',
    value: 'Cleaning Services',
  },
  {
    key: 'pet-services',
    value: 'Pet Services',
  },
  {
    key: 'convenience-pharmacies',
    value: 'Convenience & Pharmacies',
  },
  {
    key: 'other-types',
    value: 'Other Types',
  },
  {
    key: 'trip-tours-planner',
    value: 'Trip & Tours Planner',
  },
  {
    key: 'local-rental-services',
    value: 'Local Rental Services',
  },
  {
    key: 'health-personal-care',
    value: 'Health & Personal Care',
  },
  {
    key: 'sports-leisure',
    value: 'Sports & Leisure',
  },
  {
    key: 'art-culture',
    value: 'Art and Culture',
  },
  {
    key: 'food-drink',
    value: 'Food & Drink',
  },
  {
    key: 'food-and-drink',
    value: 'Food and Drink',
  },
  {
    key: 'nightlife',
    value: 'Nightlife',
  },
];

export class PlaceCategory {
  public static getPlaceCategoryKey(category: string) {
    for (let item of placeCategoryEnum) {
      if (item.value == category) {
        category = item.key;
      }
    }
    return category;
  }

  public static getPlaceCategoryValue(category: string) {
    for (let item of placeCategoryEnum) {
      if (item.key == category) {
        category = item.value;
      }
    }
    return category;
  }

  public static isIgDefaultCategory(category: string) {
    return placeCategoryEnum.any((x) => x.value === category || x.key == category);
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/constants/constant.ts